(() => {
  angular
    .module('gm.common.directives')
    .directive('gmCountryInput', gmCountryInputDirective);

  function gmCountryInputDirective(
    $filter,
    btgRegions
  ) {
    'ngInject';

    const has = Object.prototype.hasOwnProperty;
    return {
      require: 'ngModel',
      restrict: 'E',
      transclude: true,
      replace: true,
      scope: {
        blocked: '='
      },
      templateUrl: 'modules/common/directives/forms/country-input/country-input.html',

      link(scope, _element, attrs, ctrl) {
        scope.$sc = scope;
        scope.readonly = has.call(attrs, 'readonly');

        scope.countries = [];
        scope.filterInput = '';
        scope.filteredCountries = [];
        scope.activeCode = null;
        scope.activeCountry = null;

        scope.allCountries = [];

        btgRegions
          .getCountriesOptions()
          .then((countries) => {
            scope.allCountries = countries;
          });

        scope.$watchGroup(['allCountries', 'blocked'], ([allCountries, blocked]) => {
          scope.countries = getList(allCountries, blocked);
        });

        scope.$watchGroup(['filterInput', 'countries'], ([filterInput, countries]) => {
          scope.filteredCountries = $filter('filter')(countries, filterInput);
        });

        // Updates country when model changes.
        scope.$watch(() => ctrl.$modelValue, (activeCountryCode) => {
          scope.activeCode = activeCountryCode && activeCountryCode.toLowerCase();
        });

        // Updates model when country changes.
        scope.$watchGroup(['activeCode', 'countries'], ([origActiveCountryCode]) => {
          let activeCountryCode = origActiveCountryCode;
          if (activeCountryCode) {
            scope.activeCountry = scope.countries
              .find(c => c.id === activeCountryCode.toUpperCase());

            activeCountryCode = activeCountryCode.toUpperCase();
          } else {
            scope.activeCountry = null;
          }

          ctrl.$setViewValue(activeCountryCode);
        });

        scope.setActiveCode = (activeCode) => {
          scope.activeCode = activeCode;
        };
      }
    };

    function getList(allCountries, origBlocked = []) {
      const blocked = origBlocked.map(b => b.toUpperCase());
      return allCountries.filter(c => blocked.indexOf(c.id) === -1);
    }
  }
})();
